import graphql from "babel-plugin-relay/macro";
import { useCallback } from "react";

import { useMutationWithError } from "@/utils/hooks/useMutationWithError";
import { useFlags } from "@/utils/launchDarkly/useFlags";

import {
  BookingType,
  useUpdateBookingPunchPassMutation,
} from "./__generated__/useUpdateBookingPunchPassMutation.graphql";

export const useUpdateBookingPunchPass = (
  bookingType: BookingType,
  membershipTypeId: string
) => {
  const { patronLoyalty } = useFlags();
  const [commitMutation, isUpdating] =
    useMutationWithError<useUpdateBookingPunchPassMutation>(
      useUpdateBookingPunchPassMutationString
    );

  const updateBookingPunchPass = useCallback(
    (
      bookingId: string,
      punchPassId: string | null,
      onCompleted: () => void
    ) => {
      commitMutation({
        variables: {
          input: {
            bookingId,
            punchPassId,
          },
          bookingType,
          membershipTypeId,
          patronLoyalty: !!patronLoyalty,
        },
        onCompleted: () => {
          onCompleted();
        },
      });
    },
    [commitMutation, bookingType, membershipTypeId, patronLoyalty]
  );

  return [updateBookingPunchPass, isUpdating] as const;
};

const useUpdateBookingPunchPassMutationString = graphql`
  mutation useUpdateBookingPunchPassMutation(
    $input: UpdateBookingPunchPassInput!
    $bookingType: BookingType!
    $membershipTypeId: ID!
    $patronLoyalty: Boolean!
  ) {
    responsePayload: updateBookingPunchPass(input: $input) {
      booking {
        id
        ...BookingSummary_booking @arguments(patronLoyalty: $patronLoyalty)
      }
      errors {
        field
        code
        message
      }
      success
    }
  }
`;
